import * as R from "ramda";

export const setAtIndex = (i, val, list) => R.pipe(R.remove(i, 1), R.insert(i, val))(list);

export const compact = R.reject(R.isNil);
export const isIntersecting = (a, b) => R.pipe(R.intersection(b), R.complement(R.isEmpty))(a);

export const filterByPropValues = R.curry((prop, list, entities) =>
  R.filter(R.pipe(R.prop(prop), R.includes(R.__, list)), entities),
);
export const filterByIds = filterByPropValues("id");
export const indexByID = R.indexBy(R.prop("id"));
export const overlaps = R.pipe(R.intersection, R.complement(R.isEmpty));
export const isBlank = R.anyPass([R.isEmpty, R.isNil]);
export const isPresent = R.complement(isBlank);
export const isFalsy = R.anyPass([R.isEmpty, R.complement(Boolean)]);
export const isString = (s) => typeof s === "string" || s instanceof String;
export const isPromise = (p) => typeof p === "object" && typeof p.then === "function";

export const sortByDateAttr = (collection, attr) =>
  R.sort((a, b) => {
    const [d1, d2] = R.map((d) => (d[attr] ? new Date(d[attr]) : new Date(0)), [a, b]);
    return d2.getTime() - d1.getTime();
  }, collection);

export const orderByStringAttr = (collection, attr) => sorterOn(attr)(collection);

export const sorterOn = (attr) =>
  R.sort((a, b) =>
    R.propOr("", attr, a).toLowerCase().localeCompare(R.propOr("", attr, b).toLowerCase()),
  );

export const arrayWrap = (elem) => (Array.isArray(elem) ? elem : [elem]);

export const mapIndexed = R.addIndex(R.map);
export const indexedAll = R.addIndex(R.all);
export const firstPresent = (props, obj) =>
  R.pipe(
    R.props(props),
    R.find((o) => !R.isNil(o)),
  )(obj);

/**
 * Creates a new object with the own properties of the provided object, but the
 * keys renamed according to the keysMap object as `{oldKey: newKey}`.
 * When some key is not found in the keysMap, then it's passed as-is.
 *
 * Keep in mind that in the case of keys conflict is behaviour undefined and
 * the result may vary between various JS engines!
 *
 * @sig {a: b} -> {a: *} -> {b: *}
 */
export const renameKeys = R.curry((keysMap, obj) =>
  R.reduce((acc, key) => R.assoc(keysMap[key] || key, obj[key], acc), {}, R.keys(obj)),
);

export const mapKeys = R.curry((fn, obj) => R.fromPairs(R.map(R.adjust(0, fn), R.toPairs(obj))));

export const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
export const sumFloats = (floats) => R.sum(R.map(parseFloat, floats));

export const EMPTY_OBJECT = {};
export const EMPTY_ARRAY = [];
